import _extends from "@babel/runtime/helpers/extends";
import React, { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet';
import PageLoadingSpinner from '@jobmatchme/ui/es/components/PageLoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ExportAppContainer = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: 'faq' */'./');
});
export default (function (props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Helmet, {
      children: [/*#__PURE__*/_jsx("title", {
        children: "FAQ: Fragen rund um TruckJobs by JobMatch"
      }), /*#__PURE__*/_jsx("meta", {
        name: "description",
        content: "H\xE4ufig gestellte Fragen rund um TruckJobs. Wie funktioniert und f\xFCr wen ist Truckjobs gedacht? Hier bekommen Sie Ihre Antwort!"
      }), /*#__PURE__*/_jsx("meta", {
        name: "keywords",
        content: "LKW Fahrer Job, LKW Fahrer gesucht, Kraftfahrer Job, LKW Fahrer Stellenangebote, Kraftfahrer Stellenangebote, Kraftfahrer gesucht"
      })]
    }), /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(PageLoadingSpinner, {
        fullHeight: true
      }),
      children: /*#__PURE__*/_jsx(ExportAppContainer, _extends({}, props))
    })]
  });
});